"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExactApiParams = exports.getDomainToCheckConsideringTld = exports.getDomainAndTld = exports.constructSapiPost = exports.constructSapiPackageDomain = exports.commonResolve = exports.chooseTld = exports.addDataToUipMutate = void 0;
exports.getExactPromise = getExactPromise;
exports.getFindApiHeaders = exports.getExtraParams = void 0;
exports.getMerchRecommendPromise = getMerchRecommendPromise;
exports.validateAndFixResellerBaseUrl = exports.uipGraphQlQuery = exports.separateDomain = exports.removeDataFromUipMutate = exports.internal = exports.initializeDomainServices = exports.getUipMutateData = exports.getUipGraphQlQuery = exports.getSpinsPromise = exports.getSingleQueryValue = exports.getSAPIHeaders = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _utils = require("@site/utils");
var _DomainServices = require("./DomainServices");
/* eslint-disable camelcase */
/* eslint-disable max-len */

const DOMAIN_FIND_PROXY_PREFIX = '_domainFindProxy';
const getVisitorId = () => {
  return window.decodeURIComponent((0, _utils.getCookie)('visitor')).split('=')[1];
};

/**
 * @method initializeDomainServices
 * @param {String} apiKey api key
 * @param {Object} overrides Overrides
 * @param {String} urlOverride url override
 * @param {String} plid plid
 * @param {String} env env
 * @returns {Object} {DomainServices}
 */
const initializeDomainServices = ({
  apiKey,
  plid = '1',
  urlOverride = '',
  env = ''
}, overrides = {}) => {
  return new _DomainServices.DomainServices({
    apiKey: apiKey,
    plid: plid,
    env: env || (0, _utils.getEnv)(urlOverride),
    resellerBaseOverride: urlOverride,
    market: _jsCookie.default.get('market') || 'en-US',
    fetchEntity: global.fetch || {},
    ...overrides
  });
};
exports.initializeDomainServices = initializeDomainServices;
const constructSapiPackageDomain = ({
  name,
  phase
}) => {
  const nameIsPlural = name.includes(',');
  return nameIsPlural ? {
    domains: name.split(',').map(nameDotSplit => {
      return {
        name: nameDotSplit
      };
    })
  } : {
    domain: {
      name,
      ...(phase ? {
        phase
      } : {})
    }
  };
};

/**
 * Constructs a SAPI Post object based on given product-specifics.
 * @param {string} trackingCode itc code for the user session.
 * @param {Object[]} products - The Products to create a SAPI Post for.
 * @param {string} products[].name - The name of the product. Often found as Fqdn.
 * @param {string} products[].packageIdOverride - Override of pkgid for the products package. Example 'dbs' if domain is DBS.
 * @param {string} products[].phase - Phase of product package. Example/ PreReg Domains products.
 * @param {string} products[].redemptioncode - The redemption code to apply to the product package.
 * @param {string|Object} products[].term - The term to apply to the product package.
 * @returns {Object} the postData to send to a SAPI Post AddToCart
 */
exports.constructSapiPackageDomain = constructSapiPackageDomain;
const constructSapiPost = ({
  trackingCode,
  products = [],
  additionalPackageAttributes = {},
  additionalPostDataAttributes = {}
}) => {
  const domainMonthlyTerm = !products?.[0]?.term && (0, _utils.getDomainMonthlyTerms)({
    product: {
      priceInfo: products?.[0]?.PriceInfo
    }
  })?.term;
  return {
    itc: trackingCode,
    fullAvailCheck: true,
    packages: products.map(({
      packageIdOverride,
      name,
      phase,
      redemptioncode,
      term,
      addOns
    }) => {
      return {
        pkgid: packageIdOverride || 'domain',
        ...constructSapiPackageDomain({
          name,
          phase
        }),
        ...(redemptioncode && {
          redemptioncode
        }),
        ...(term && {
          term
        }),
        ...(domainMonthlyTerm && {
          term: `${domainMonthlyTerm}:Month`
        }),
        ...(addOns && {
          addOns
        }),
        ...additionalPackageAttributes
      };
    }),
    ...additionalPostDataAttributes
  };
};
exports.constructSapiPost = constructSapiPost;
const getExactApiParams = ({
  timeOffset
}) => {
  return {
    ...(timeOffset && {
      timeOffset
    })
  };
};
exports.getExactApiParams = getExactApiParams;
const getSingleQueryValue = queryParam => {
  if (Array.isArray(queryParam) && typeof queryParam[0] === 'string') {
    return queryParam[0].trim();
  }
  if (typeof queryParam === 'string') {
    return queryParam.trim();
  }
  return '';
};

// TODO: NXT-2266 Remove getDomainToCheckConsideringTld once we have bumped domain-services in serp-app and domain-iq-ui
exports.getSingleQueryValue = getSingleQueryValue;
const getDomainToCheckConsideringTld = ({
  domainToCheck = '',
  tld = ''
}) => {
  domainToCheck = getSingleQueryValue(domainToCheck);
  tld = getSingleQueryValue(tld);
  if (tld.length === 0 || domainToCheck.length === 0) return domainToCheck;
  tld = tld.indexOf('.') >= 0 ? tld : `.${tld}`;
  return /.*\..*/.test(domainToCheck) ? domainToCheck : `${domainToCheck}${tld}`;
};
exports.getDomainToCheckConsideringTld = getDomainToCheckConsideringTld;
const separateDomain = domainFromQuery => {
  const [domainName, ...domainTldParts] = domainFromQuery.split('.');
  const domainTld = domainTldParts.join('.');
  return {
    domainTld,
    domainName
  };
};
exports.separateDomain = separateDomain;
const chooseTld = ({
  urlTld,
  domainTld
}) => {
  const tld = domainTld ? domainTld : urlTld;
  if (tld && tld.startsWith('.')) {
    return tld.substring(1).trim();
  }
  return tld?.trim();
};
exports.chooseTld = chooseTld;
const getDomainAndTld = ({
  domainToCheck = '',
  tld = ''
}) => {
  domainToCheck = getSingleQueryValue(domainToCheck);
  tld = getSingleQueryValue(tld);
  const {
    domainName,
    domainTld
  } = separateDomain(domainToCheck);
  const tldToUse = chooseTld({
    urlTld: tld,
    domainTld
  });
  const hasTld = tldToUse && tldToUse.length > 0;
  const hasDomain = domainName && domainName.length > 0;
  const domainWithTld = hasTld && hasDomain ? `${domainName}.${tldToUse}` : domainName;
  return {
    domainWithTld,
    tld: tldToUse
  };
};

/**
 * Gets the extra parameters for domain find apis.
 * @param {String} apiKey Source api key
 * @param {Number} req_id Unix timestamp in microseconds within 1 hour of current time
 * @param {String} isc ISC code for discounts
 * @param {String} itc ITC to inject for tracking purposes
 * @param {String} domainToCheck Domain to check
 * @param {String} partialQuery Partial query
 * @param {String} searchGuid A Guid which uniquely identifies a search on SERP
 * @param {String} dbsPackage package id override for dbs
 * @param {String} annualTermMonthlyPaymentPackage atmp package
 * @param {String} tlds tlds separated by commas
 * @returns {Object} {{req_id: number, isc: string, itc: string}}
 */
exports.getDomainAndTld = getDomainAndTld;
const getExtraParams = ({
  apiKey,
  req_id = Date.now(),
  isc = '',
  itc = '',
  domainToCheck,
  partialQuery,
  searchGuid,
  bundleTlds,
  dbsPackage,
  annualTermMonthlyPaymentPackage,
  tlds
}) => {
  const hasPartialQuery = partialQuery && partialQuery !== '';
  const partial_query = hasPartialQuery ? partialQuery : domainToCheck;
  return {
    ...(apiKey && {
      apiKey
    }),
    ...(searchGuid && {
      search_guid: searchGuid
    }),
    req_id,
    isc,
    itc,
    ...(partial_query && {
      partial_query
    }),
    ...(bundleTlds && {
      verify_tlds: bundleTlds
    }),
    ...(dbsPackage && {
      dbs_package: dbsPackage
    }),
    ...(annualTermMonthlyPaymentPackage && {
      atmp: annualTermMonthlyPaymentPackage
    }),
    ...(tlds && {
      tlds
    })
  };
};
exports.getExtraParams = getExtraParams;
const getFindApiHeaders = ({
  referrer,
  isCypress,
  traceparent
} = {}) => {
  const isbrowser = (0, _utils.isBrowser)();
  const commonHeaders = {
    ['X-Referrer']: encodeURI(referrer || isbrowser && document.referrer || ''),
    traceparent: traceparent || isbrowser && document.querySelector('meta[name="gd:traceId"]')?.content || ''
  };
  if (isCypress || isbrowser && window.Cypress) {
    commonHeaders['X-Gd-Crawler'] = 'cypress';
  }
  return commonHeaders;
};
exports.getFindApiHeaders = getFindApiHeaders;
const getSAPIHeaders = ({
  isCypress,
  traceparent
} = {}) => {
  const isbrowser = (0, _utils.isBrowser)();
  const commonHeaders = {
    ['Content-Type']: 'application/json',
    traceparent: traceparent || isbrowser && document.querySelector('meta[name="gd:traceId"]')?.content || ''
  };
  if (isCypress || isbrowser && window.Cypress) {
    commonHeaders['X-GD-SerpTest'] = 'true';
    commonHeaders['X-GD-Crawler'] = 'cypress';
  }
  return commonHeaders;
};
exports.getSAPIHeaders = getSAPIHeaders;
const commonResolve = async (response, info = '') => {
  if (!response.ok) {
    const json = response.json && response.json();
    throw Error(JSON.stringify({
      info,
      statusText: json
    }));
  }
  const data = await response.json();
  return {
    status: response.status,
    statusText: response.statusText,
    data: data
  };
};
exports.commonResolve = commonResolve;
const getUipGraphQlQuery = ({
  visitorId,
  targetData
}) => {
  const query = `
  query Query($identifier: UserIdentifier){
   user(identifier: $identifier){
     id,
     idType,
     godaddy {
      marketing {
        ${targetData}
       }
     }
   }
 }`;
  return {
    query,
    variables: {
      identifier: {
        id: visitorId,
        idType: 'visitorId'
      }
    }
  };
};
exports.getUipGraphQlQuery = getUipGraphQlQuery;
const getUipMutateData = ({
  insightName,
  operation,
  domainName,
  productName,
  visitorId,
  dateAdded,
  availability
}) => {
  const stringifiedProduct = JSON.stringify({
    dateAdded,
    name: domainName,
    product: productName,
    availability
  });
  return {
    users: [{
      insights: [{
        brand: 'godaddy',
        namespace: 'marketing',
        insightName,
        insightValue: [stringifiedProduct],
        operation
      }],
      identifier: {
        visitorId
      }
    }]
  };
};
exports.getUipMutateData = getUipMutateData;
const uipGraphQlQuery = async ({
  targetData,
  plid,
  urlOverride,
  onError = () => {}
}) => {
  const visitorId = getVisitorId();
  const query = getUipGraphQlQuery({
    visitorId,
    targetData
  });
  const {
    getUipApiPromise
  } = initializeDomainServices({
    plid,
    apiKey: 'serp',
    urlOverride
  });
  return getUipApiPromise({
    inputData: query,
    endpoint: 'graphql'
  }).then(arg => commonResolve(arg, 'getUipApiPromise')).catch(error => {
    onError({
      error,
      targetData
    });
  });
};
exports.uipGraphQlQuery = uipGraphQlQuery;
const addDataToUipMutate = ({
  domainName,
  productName = 'domain',
  onError = () => {},
  plid = 1,
  insightName,
  availability,
  urlOverride
}) => {
  const visitorId = getVisitorId();
  const inputData = getUipMutateData({
    dateAdded: new Date().getTime(),
    insightName,
    operation: 'APPEND_DISTINCT',
    domainName,
    productName,
    visitorId,
    availability
  });
  const {
    getUipApiPromise
  } = initializeDomainServices({
    plid,
    apiKey: 'serp',
    urlOverride
  });
  return getUipApiPromise({
    inputData,
    endpoint: 'mutate'
  }).catch(error => {
    onError({
      error,
      domainName,
      insightName
    });
  });
};
exports.addDataToUipMutate = addDataToUipMutate;
const removeDataFromUipMutate = ({
  dateAdded,
  domainName,
  productName = 'domain',
  onError = () => {},
  plid = 1,
  insightName,
  availability,
  urlOverride
}) => {
  const visitorId = getVisitorId();
  const inputData = getUipMutateData({
    dateAdded,
    insightName,
    operation: 'REMOVE_BY_VALUE',
    domainName,
    productName,
    visitorId,
    availability
  });
  const {
    getUipApiPromise
  } = initializeDomainServices({
    plid,
    apiKey: 'serp',
    urlOverride
  });
  return getUipApiPromise({
    inputData,
    endpoint: 'mutate'
  }).catch(error => {
    onError({
      error,
      domainName,
      insightName
    });
  });
};
exports.removeDataFromUipMutate = removeDataFromUipMutate;
const validateAndFixResellerBaseUrl = resellerBaseUrl => {
  for (const url of _utils.alternateResellerBaseUrls) {
    const alternateUrlRegex = new RegExp(url, 'i');
    if (alternateUrlRegex.test(resellerBaseUrl))
      // Some pathways might include a leading www. so let's strip it off if present.
      return resellerBaseUrl.replace(/^www\./, '');
  }
  return 'secureserver.net';
};
exports.validateAndFixResellerBaseUrl = validateAndFixResellerBaseUrl;
const proxifyDomainFindApiCall = (env, url, isCypress = false) => {
  const locals = ['local', 'localtest', 'localprod'];
  // Hitting a bunch of tricky 403 issues when running the proxy for Cypress tests so let's not do that
  if (!locals.includes(env) || isCypress) return url;
  const urlRegex = new RegExp(`(${_utils.validBaseUrlMatches.join('|')})/([a-z]{2}/)?`, 'i');
  return url.replace(/https:\/\/(www|[a-z]{2})./i, 'https://www.localhost.').replace(urlRegex, `$1:8484/${DOMAIN_FIND_PROXY_PREFIX}/`);
};

/**
 * @method getSpinsPromise
 * @description Gets spins api promise.
 * @param {JSON} params (apiKey, searchTerm, numberOfSpins)
 * @param  {String} urlOverride override for host. Example: dev-godaddy.com
 * @param  {object} apm optional, apm instance
 * @returns {object} promise
 */
const getSpinsPromise = (params, urlOverride, apm) => {
  const {
    selectedSuggestion,
    searchTerm,
    numberOfSpins,
    apiKey,
    plid,
    isc,
    itc,
    tlds,
    pagestart,
    dbsPackage
  } = params;
  const query = selectedSuggestion || searchTerm;
  const spinsParams = {
    pagestart: pagestart || 0,
    pagesize: numberOfSpins || 3
  };
  const domainServices = initializeDomainServices({
    apiKey,
    plid,
    urlOverride
  });
  const spinsApiSpan = apm?.startSpan?.('spinsApi');
  const spinsPromise = domainServices.findSpinsPromise({
    query,
    extraParams: {
      ...getExtraParams({
        isc,
        itc,
        domainToCheck: query,
        partialQuery: searchTerm,
        apiKey,
        tlds,
        dbsPackage
      }),
      ...spinsParams
    },
    options: {
      headers: getFindApiHeaders()
    }
  }).then(arg => {
    spinsApiSpan?.end();
    return commonResolve(arg, 'findSpinsPromise');
  });
  return spinsPromise.then(spinsData => Promise.resolve(spinsData)).catch(error => Promise.reject(error));
};

/**
 * @method getMerchRecommendPromise
 * @description Gets merchRecommend api promise.
 * @param {JSON} params (plid, resellerBaseOverride, apiKey, merchRecommendApiOptions, userShopperId, market, language, visitorGuid, vGuid, isc, itc, domainSource, geoCountryCode, geoCity, geoRegion, geoZipCode, geoClientId, paginationSize, serverCurrency, serverPlid, visitor)
 * @param  {object} apm optional, apm instance
 * @returns {object} promise
 */
// eslint-disable-next-line complexity
exports.getSpinsPromise = getSpinsPromise;
async function getMerchRecommendPromise(params, apm) {
  const {
    plid,
    resellerBaseOverride,
    apiKey,
    userShopperId,
    market,
    language,
    visitorGuid,
    vGuid,
    isc,
    itc,
    domainSource,
    geoCountryCode,
    geoCity,
    geoRegion,
    geoZipCode,
    geoClientId,
    paginationSize,
    serverCurrency,
    serverPlid,
    visitor
  } = params;
  const domainServices = initializeDomainServices({
    plid,
    apiKey,
    resellerBaseOverride
  });
  const merchRecommendApm = apm?.startSpan?.('merchRecommendApi');
  const merchRecommendPromise = domainServices.findMerchRecommendPromise({
    options: {
      headers: getFindApiHeaders()
    },
    extraParams: {
      ...(visitor && {
        visitor: visitor
      }),
      ...(userShopperId && {
        user_shopper_id: userShopperId
      }),
      ...(market && {
        user_country_site: market
      }),
      ...(language && {
        user_language: language
      }),
      ...(visitorGuid && {
        user_visitor_guid: visitorGuid
      }),
      ...(vGuid && {
        user_vguid: vGuid
      }),
      ...(isc && {
        user_isc_code: isc
      }),
      ...(itc && {
        user_itc_code: itc
      }),
      ...(domainSource && {
        domain_source: domainSource
      }),
      ...(geoCountryCode && {
        geo_country_code: geoCountryCode
      }),
      ...(geoCity && {
        geo_city: geoCity
      }),
      ...(geoRegion && {
        geo_region: geoRegion
      }),
      ...(geoZipCode && {
        geo_zip_code: geoZipCode
      }),
      ...(geoClientId && {
        geo_client_ip: geoClientId
      }),
      ...(paginationSize && {
        pagination_size: paginationSize
      }),
      ...(serverCurrency && {
        server_currency: serverCurrency
      }),
      ...(serverPlid && {
        server_private_label_id: serverPlid
      })
    }
  }).then(arg => {
    merchRecommendApm?.end();
    return commonResolve(arg, 'findMerchRecommendPromise');
  });
  return merchRecommendPromise.then(data => Promise.resolve(data)).catch(error => Promise.reject(error));
}

/**
 * Gets exact api results.
 *
 * @param {JSON} params (apiKey, searchTerm)
 * @param  {String} urlOverride override for host. Example: dev-godaddy.com
 * @param  {object} apm optional, apm instance
 * @returns {object} promise
 */
function getExactPromise(params, urlOverride, apm) {
  const {
    selectedSuggestion,
    searchTerm,
    apiKey,
    plid,
    isc,
    itc,
    dbsPackage,
    annualTermMonthlyPaymentPackage
  } = params;
  const query = selectedSuggestion || searchTerm;
  const queryParams = new URLSearchParams(window.location.search);
  const timeOffset = queryParams.get('time_offset');
  const exactParams = {
    ...(timeOffset && {
      timeOffset
    })
  };
  const domainServices = initializeDomainServices({
    apiKey,
    plid,
    urlOverride
  });
  const exactApiSpan = apm?.startSpan?.('exactApi');
  const exactPromise = domainServices.findExactPromise({
    query,
    extraParams: {
      ...getExtraParams({
        isc,
        itc,
        domainToCheck: query,
        partialQuery: searchTerm,
        apiKey,
        dbsPackage,
        annualTermMonthlyPaymentPackage
      }),
      ...exactParams
    },
    options: {
      headers: getFindApiHeaders()
    }
  }).then(arg => {
    exactApiSpan?.end();
    return commonResolve(arg, 'findExactPromise');
  });
  return exactPromise.then(exactMatchData => Promise.resolve(exactMatchData)).catch(error => Promise.reject(error));
}
const internal = exports.internal = {
  proxifyDomainFindApiCall,
  DOMAIN_FIND_PROXY_PREFIX
};